import {
  selectSearchListingsTotal,
  selectHomebotListingsSearchLoading,
} from '../../../../store/selectors/listings'
import { useEffect } from 'react'
import { ListViewItem } from './ListViewItem'
import { SearchListing } from '../../../../types/listings'
import { useSelector, useDispatch } from 'react-redux'
import { FadeOnMount } from '../../../shared/Animations'
import { fetchFavoriteListings } from '../../../../actions/favoriteListings'
import { LoadMoreListings } from '../LoadMoreListings'

import styles from './ListView.module.scss'

export interface ListViewProps {
  customerId: string
  handleHoverAndFocusChange: () => void
  assignListingRef: string
  listings: SearchListing[]
  listingsDispatch: () => void
  focusedListing: SearchListing
}

export const ListView = ({
  handleHoverAndFocusChange,
  listings,
  customerId,
  assignListingRef,
  listingsDispatch,
}: ListViewProps) => {
  const dispatch = useDispatch()
  const listingsTotal = useSelector(selectSearchListingsTotal)
  const loading = useSelector(selectHomebotListingsSearchLoading)

  useEffect(() => {
    dispatch(fetchFavoriteListings(customerId))
  }, [dispatch, customerId])

  return (
    <>
      <ul className={styles.listView}>
        {listings?.map(listing => {
          return (
            <FadeOnMount key={listing.id}>
              <ListViewItem
                key={listing.id}
                listing={listing}
                handleHoverAndFocusChange={handleHoverAndFocusChange}
                customerId={customerId}
                listingsDispatch={listingsDispatch}
                assignListingRef={assignListingRef}
              />
            </FadeOnMount>
          )
        })}
      </ul>
      {!loading && listings?.length < listingsTotal && <LoadMoreListings />}
    </>
  )
}
